import { EMP_SET_EMPRESA_SUCCESS,EMP_FETCH_EMPRESAS_SC_ENTRADA_SUCCESS, EMP_SET_EMPRESAS_SUCCESS, EMP_FETCH_EMPRESAS_MT_SUCCESS, EMP_FETCH_EMPRESAS_GO_ENTRADA_SUCCESS } from '../actions/types';

const INITIAL_STATE = {
  dadosEmpresa: {
    codigo: 0,
    tipoInscricao: '1',
    inscricao: '',
    razaoSocial: '',
    nomeFantasia: '',
    emailPrincipal: '',
    telefone: '',
    celular: '',
  },
  empresas: [],
  empresasMt: [],
  empresasGoEntrada: [],
  empresasSC: []
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case EMP_SET_EMPRESA_SUCCESS:
      return { ...state, dadosEmpresa: payload };
    case EMP_SET_EMPRESAS_SUCCESS:
      return { ...state, empresas: payload };
    case EMP_FETCH_EMPRESAS_MT_SUCCESS:
      return { ...state, empresasMt: payload };
    case EMP_FETCH_EMPRESAS_GO_ENTRADA_SUCCESS:
      return { ...state, empresasGoEntrada: payload };
    case EMP_FETCH_EMPRESAS_SC_ENTRADA_SUCCESS:
      return { ...state, empresasSC: payload };
    default:
      return state;
  }
};
